import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {
  selectedAdditionalCheckBoxReducer,
  initialSelectedCheckBoxState
} from '@shared/context/reducers/SelectedAdditionalReducers';
import {setSelectedAdditionalCheckBox} from '@shared/context/actions/SelectedAdditionalBoxActions';
import {SelectedAdditionalCheckBoxModel} from '@shared/context/mappers/SelectedAdditionalCheckBoxTypes';

interface SelectedCheckBoxInterface {
  readonly SelectedAdditionalCheckBoxState: SelectedAdditionalCheckBoxModel;
  readonly setSelectedAdditionalCheckBoxData: (data: object) => void;
}

const SelectedCheckBoxContext = createContext<SelectedCheckBoxInterface>(
  {} as SelectedCheckBoxInterface
);

export const useSelectedAdditionalCheckBoxContext = (): SelectedCheckBoxInterface =>
  useContext(SelectedCheckBoxContext);

export const SelectedAdditionalCheckBoxProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [SelectedAdditionalCheckBoxState, dispatch] = useReducer(
    selectedAdditionalCheckBoxReducer,
    initialSelectedCheckBoxState
  );

  const setSelectedAdditionalCheckBoxData = (data: any): void => {
    setSelectedAdditionalCheckBox(dispatch, data);
  };

  return (
    <SelectedCheckBoxContext.Provider
      value={{
        SelectedAdditionalCheckBoxState,
        setSelectedAdditionalCheckBoxData
      }}>
      {children}
    </SelectedCheckBoxContext.Provider>
  );
};
